import React, { useEffect, useState } from 'react';
import { deleteEntityLink, fetchEntityLinks } from '../services/intelligenceApi';
import DeleteButton from './DeleteButton';
import EntityPivotLink from './EntityPivotLink';
import { relationLabel } from '../config/entityRoutes';

function isStoredLink(linkId) {
  return Boolean(linkId) && !String(linkId).startsWith('implicit-');
}

function RelationshipTable({
  entityType,
  entityId,
  emptyMessage = 'No relationships yet.',
  allowDelete = true,
  refreshKey = 0,
  onChanged,
}) {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    if (!entityType || !entityId) return;
    setLoading(true);
    fetchEntityLinks(entityType, entityId)
      .then((res) => setLinks(res.data.links || []))
      .catch(() => setLinks([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [entityType, entityId, refreshKey]);

  if (loading) {
    return <p style={{ color: 'var(--hdp-text-muted)' }}>Loading relationships...</p>;
  }

  if (links.length === 0) {
    return <p style={{ color: 'var(--hdp-text-muted)' }}>{emptyMessage}</p>;
  }

  return (
    <table className="data-table entity-table">
      <thead>
        <tr>
          <th>Relation</th>
          <th>Entity</th>
          <th>Direction</th>
          {allowDelete && <th />}
        </tr>
      </thead>
      <tbody>
        {links.map((link) => (
          <tr key={link.link_id}>
            <td>{relationLabel(link.relation)}</td>
            <td>
              <EntityPivotLink
                type={link.other_type}
                id={link.other_id}
                label={link.other_label}
                iocType={link.other_ioc_type}
              />
            </td>
            <td>{link.direction}</td>
            {allowDelete && (
              <td>
                {isStoredLink(link.link_id) ? (
                  <DeleteButton
                    confirmMessage="Remove this relationship?"
                    onDelete={async () => {
                      await deleteEntityLink(link.link_id);
                      setLinks((prev) => prev.filter((row) => row.link_id !== link.link_id));
                      onChanged?.();
                    }}
                  />
                ) : (
                  <span style={{ color: 'var(--text-muted)', fontSize: '12px' }}>implicit</span>
                )}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default RelationshipTable;
